module.exports = __webpack_public_path__ + "static/conveyor-ff080e3a8348d6a6f99b801b8516cb40.png";